import { useTranslation } from '@spcc/core'
import { Truck, TableEmptyState } from '@spcc/uikit'
import type { ShipmentsEmptyStateProps } from '../types'

export function ShipmentsEmptyState({}: ShipmentsEmptyStateProps) {
  const { t } = useTranslation()

  return (
    <div className="glass-card rounded-2xl overflow-hidden">
      <TableEmptyState
        icon={Truck}
        title={t('shipments.noShipments')}
        description={t('shipments.noShipmentsDescription')}
      />
    </div>
  )
}
